/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IssueTemplateUserMode {
    Form = '0',
    Chat = 1,
}
